<template>
    <b-modal size="fullscreen" ref="report-details-modal" hide-header hide-footer body-class="p-0">
        <div class="container-modal h-100 w-100">
            <div class="modal-header bg-primary d-flex justify-content-between">
                <div class="report-details-header d-flex flex-row align-items-center">
                    <img :src="require(`@/assets/img/devices/${icon}.png`)">
                    <div class="d-flex flex-column">
                        <p class="text-light m-0 ms-3 fw-bold">{{ plate }}</p>
                        <div class="d-flex report-variable-1 flex-wrap">
                            <p class="text-light m-0 ms-3"><strong class="me-1">De:</strong> {{ from }}</p>
                            <p class="text-light m-0 ms-3"><strong class="me-1">A:</strong> {{ to }}</p>
                        </div>
                    </div>
                </div>
                <div class="close-modal d-flex" @click="close">
                    <img src="@/assets/img/close.svg">
                </div>
            </div>
            <div class="report-content d-flex" style="height: calc(100dvh - 125px); overflow-y: auto;">
                <div class="report-details-tabl h-100 w-100">
                    <ReportDetailTable :data="data" :device="device" id="container-table-id"></ReportDetailTable>
                </div>
            </div>
            <!-- <hr class="my-1"> -->
            <div class="report-options d-flex flex-row align-items-center justify-content-center p-2" style="height: 55px;">
                <b-button class="mx-1 h-100" @click="close">Cerrar</b-button>
                <div class="btn btn-danger mx-1 h-100" @click="exportPdf">
                    <img src="@/assets/img/export-pdf.svg" class="h-100">
                </div>
                <div class="btn btn-success mx-1 h-100" v-if="false">
                    <img src="@/assets/img/export-excel.svg" class="h-100">
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script lang="ts">
import GeneratePdfService from '@/api/services/generate-pdf.service';
import PositionDto from '@/models/dto/position.dto';
import ReportService from '@/services/report.service';
import globalModule from '@/store/modules/global.module';
import { Component, Vue } from 'vue-property-decorator';
import ReportDetailTable from '../tables/ReportDetailTable.vue';
@Component({
    components: {
        ReportDetailTable
    },
})
export default class ReportDetails extends Vue {

    icon = '0'
    plate = 'NaN'
    from = 'HH:MM DD/MM/YYYY'
    to = 'HH:MM DD/MM/YYYY'
    data: PositionDto[] = []
    device: any = {}

    close() {
        const modal: any = this.$refs['report-details-modal']
        modal.hide();
    }

    show() {
        const modal: any = this.$refs['report-details-modal']
        modal.show();
    }

    async exportPdf() {
        this.init();
        const pdfParams = ReportService.formatGenericData(this.data)
        const base64 = (await GeneratePdfService.getBase64(this.plate, 'Detallado', this.from, this.to, pdfParams)).data.base64
        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${base64}`;
        link.download = `report-${this.plate}.pdf`;
        link.click();
        this.end();
    }

    init() {
        globalModule.generatePdfLoader.visible = true
        globalModule.generatePdfLoader.text = 'Generando PDF...'
        globalModule.generatePdfLoader.success = false
    }

    end() {
        globalModule.generatePdfLoader.success = true
        globalModule.generatePdfLoader.text = 'PDF Descargado'
        setTimeout(() => {
            globalModule.generatePdfLoader.visible = false
        }, 3000);
    }
}

</script>

<style lang="sass">
    @import '@/assets/style/variables.sass'
    table
        font-family: 'Changa', sans-serif !important
    .modal-header
        height: 60px !important
        img
            height: 45px

    .close-modal
        height: 20px
        cursor: pointer
        transition: all .1s ease
        &:active
            transform: scale(0.9)
        img
            height: 100%
    
    .report-options
        .btn
            transition: all 0.1s ease
            &:active
                transform: scale(0.9)

    @media screen and (max-width: $medium-screen)
        .report-details-header
            .report-variable-1
                flex-direction: column !important
            p
                font-size: 14px !important
                margin-bottom: -5px !important

    
</style>